import EasyPdf from "utils/easyPdf";
import { createCanvas } from "canvas";
import QRcode from 'qrcode';
import logo from 'assets/pdf/LogoGobierno_21_27.png'
import logoSeguridad from 'assets/pdf/logoSeguridad.png'
import linea from 'assets/img/lineas/linea.png'
import firma from 'assets/pdf/firma.png'
import logoTransito from 'assets/pdf/TransitoEstatal2.png'

export const createPermitionProvitional = async (params) => {

  const sdoc = new EasyPdf(15, 20, { fontSize: 12 });
  const [initialDay, initialMont, initialYear] = params.fechaInicial.split('-');
  const [limitDay, limitMont, limitYear] = params.fechaLimite.split('-');
  const [expdDay, expdMont, expYear] = params.fechaExpedido.split('-');

  sdoc.title('VÁLIDO POR 30 DÍAS');
  sdoc.addImage(logo, 'JPG', 18, 25, { lastPosition: true, x: 5 });
  sdoc.addImage(logoSeguridad, 'JPG', 20, 19, { y: 7.5, position: 'right' });

  sdoc.textWithBold('Núm Oficio:', `SSP/DGT/${params.folioPermiso}/${expYear}`, 122, 30, { color: '#880e33' });
  sdoc.textWithBold('Asunto:', 'Permiso temporal para circular sin placas por trámite de Emplacamiento', 122, 35, { maxWidth: 70 });
  if (!params.permisoEstimulado) {
    sdoc.textWithBold('Modelos:', `${expYear - 1}, ${expYear} y ${parseInt(expYear) + 1}.`, 122, 44, { maxWidth: 70 });
  }

  sdoc.text(`Chilpancingo de los Bravo, Gro., a ${expdDay} de ${getMont(expdMont)} del ${expYear}`, { x: 122, y: 48, fontSize: 9 });
  sdoc.text('"2024, Año de Felipe Carrillo Puerto, Benemérito del Proletariado, Revolucionario y Defensor del Mayab"', { x: 43, y: 55, bold: true, fontSize: 10 });

  sdoc.listText([
    'C. AUTORIDADES FEDERALES DE LA FISCALÍA GENERAL DE LA REPÚBLICA',
    'C. AUTORIDADES ESTATALES DE SEGURIDAD PÚBLICA',
    'C. AUTORIDADES MUNICIPALES DE SEGURIDAD PÚBLICA',
    'P R E S E N T E S.'
  ], { y: 65, fontSize: 10, bold: true });
  sdoc.text('At\'n. Autoridades de tránsito y vialidad', { x: 122, y: 90, fontSize: 10, bold: true });
  sdoc.text('En ejercicio de la facultad que me confieren los artículos 28 de la ley de Transporte y Vialidad del Estado de Guerrero; '
    + 'así como el 26, 119 y 122 del Reglamento de la Ley de Transporte y Vialidad del Estado de Guerrero, me permito informarles que el '
    + 'vehículo que a continuación se describe, se le ha expedido y al mismo tiempo autorizado un permiso temporal '
    + 'para circular sin placas, durante el periodo comprendido del:',
    {
      y: 100, maxWidth: 180,
    });
  sdoc.text(` ${initialDay} de ${getMont(initialMont)} de ${initialYear} al ${limitDay} de ${getMont(limitMont)} de ${limitYear}.`,
    { x: 20, y: 127.5, fontSize: 18, bold: true, position: 'center' }
  );

  sdoc.text('Por lo cual, agradeceré a ustedes se brinden todas las facilidades necesarias a su conductor '
    + 'para circular todos los días y en cualquier horario, por el periodo señalado.', { y: 135, maxWidth: 185 });

  sdoc.text('CARACTERÍSTICAS DEL VEHÍCULO:', { y: 150, bold: true });

  sdoc.listTextwithBold([
    'SERIE:' + params.serie,
    'MOTOR:' + params.motorVehiculo,
    'MODELO:' + params.modeloVehiculo,
    'VEHÍCULO:' + params.cveVehic,
  ], { x: 25, y: 160, fontSize: 14, maxWidth: 85 });

  const canvasQR = createCanvas();
  QRcode.toCanvas(
    canvasQR,
    'https://esefina.ingresos-guerrero.gob.mx/Tenencia/ModuloExterno/ValidaPP.php?folio=' + params.folioPermiso + '&serie=' + params.serie,
    function (error) {
      if (error) console.error(error)
    }
  );

  const img = await loadImage(canvasQR.toDataURL());
  sdoc.addImage(
    img,
    'PNG',
    40,
    40,
    { x: 155, y: 150 }
  );

  const firmaParse = await loadImage(firma);
  await sdoc.addImage(
    firmaParse,
    'PNG',
    80,
    50,
    { x: 60, y: 200 }
  );

  const transitoParse = await loadImage(logoTransito);
  await sdoc.addImage(
    transitoParse,
    'PNG',
    90,
    80,
    { x: 60, y: 170 }
  );

  sdoc.text(`${expYear}`, { x: 157, y: 200, bold: true, fontSize: 50 });

  sdoc.text('Atentamente', { y: 210, bold: true, position: 'center' });
  sdoc.text('El Director General de Tránsito, Caminos, Puertos y Aeropuertos del Estado de Guerrero', { y: 215, bold: true, position: 'center' });

  sdoc.text('Comisario : Daniel Garcia Ortuño', { y: 235, bold: true, position: 'center' });
  sdoc.text('Nota: La autenticidad de este documento puede ser valida escaneando el código QR que se muestra en el '
    + 'presente documento, adicionalmente podrá ser verificada en el telefono 747-478-36-18. Válido para vehículos '
    + 'del servicio particular, la falsificación, alteración o uso indebido de un documento oficial se encuentra penado '
    + 'por la ley de tres meses a seis años de prisión y una multa de ciento ochenta días a trescientos sesenta días y '
    + 'de quince a noventa días de unidades de medida y actualización (UMA).Sr Agente de tránsito, para el caso de vehículos '
    + 'nacionales, los datos contenidos en este oficio, referentes a la serie, marca, submarca, modelo y motor del vehículo, '
    + 'deberán coincidir con los registros de la factura e identificación del propietario; caso contrario, este oficio no tiene validez.',
    { y: 240, fontSize: 8, maxWidth: 185 });

  sdoc.text('Valida en: https://esefina.ingresos-guerrero.gob.mx/Tenencia/ModuloExterno/ValidaPP.php', { y: 260, fontSize: 10, position: 'center' });
  sdoc.addImage(linea, 'PNG', 185, 10, { y: 260 });
  sdoc.text('Fraccionamiento Chuchululuya S/N, Int. del Aeropuerto, C.P.39014, Chilpancingo de los Bravo, Guerrero, Tel. 01 747 47 836 18 y 47 838 76, correo electrónico: transito_edo06@yahoo.com.mx.', { fontSize: 7, y: 273, position: 'center' });
  sdoc.printDocument();

}

function getMont(mont) {
  let numberMont = mont;
  if (typeof mont === 'string') {
    numberMont = parseInt(mont);
  }
  const monts = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

  return monts[numberMont - 1];
}

const loadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve(img);
    img.onerror = reject;
  })

}